export default "__VITE_ASSET__CApwOjA2__"